import PiecePerduDesktop from "./PiecePerduDesktop";

const PiecePerduMobile = () => <PiecePerduDesktop />;

export default PiecePerduMobile;
